import { AUTH_TYPES } from "../types/AuthTypes";

export const loginAction = (payload) => ({
    type: AUTH_TYPES.login,
    payload,
});

export const logoutAction = () => ({
    type: AUTH_TYPES.logout,
});